<div class="middle-east-page-container" *ngIf="!loading" [style]="tab ? 'margin-bottom: 100px' : ''">
  <app-section [style]="isMobile ? 'position: sticky; top: 0' : ''">
    <app-title-background [locationDto]="getCorrectLocation()" [hotelSection]="true"/>
  </app-section>
  <app-section style="height: calc(100vh - 80px); display: flex; flex-direction: column; justify-content: center" *ngIf="!isMobile">
    <app-running-line
      [otherText]="true"
      [text]="[{text: [this.continentDto.runningLineRu ?? 'bla-bla-bla', this.continentDto.runningLine ?? 'bla-bla-bla']}]"
    />
    <app-looped-slider [cards]="sliderCards" [grid]="grid"/>
  </app-section>
    <div *ngIf="url != 'antarctica'">
      <app-destinations-countries [alone]="true" [loadContinent]="id" [border]="true" (firstLoading)="loadingEmit($event)"/>
    </div>
  <app-section *ngIf="countryCards.length > 0">
    <app-main-busy-bee
      [texts]="destinationBusyByTitle"
      [cards]="countryCards"
    />
  </app-section>
  <app-section *ngIf="url != 'antarctica'">
    <app-main-best-hotels *ngIf="hotelCards.length > 0"
      [texts]="destinationBestHotelsTitle"
      [subtitle]="true"
      [arrows]="true"
      [cards]="hotelCards"
      [search]="true"
      [main]="false"
      [type]="'continent'"
      [typeContent]="typeContent"
    />
  </app-section>
  <app-section *ngIf="url == 'antarctica'">
    <app-background-looped-slider [locations]="routesDto" [autoplay]="true" [slideInterval]="10"/>
  </app-section>
  <div class="sticky-section-wrapper">
    <app-section
      *ngIf="routeCards.length > 0 || additionalCards.length > 0"
      class="sticky-section">
      <app-main-busy-bee
        *ngIf="url != 'antarctica' && routeCards.length > 0"
        [texts]="routesBusyByTitle"
        [cards]="routeCards"
      />
      <app-main-busy-bee
        *ngIf="url == 'antarctica' && additionalCards.length > 0"
        [texts]="routesBusyByTitle"
        [cards]="additionalCards"
      />
    </app-section>
  </div>
  <app-section-scroller class="overlapping-content">
    <app-main-destinations (ClickOnActive)="goToDestination($event)" (loadingEmit)="loadCircle($event)"/>
  </app-section-scroller>
</div>
<app-admin-preview [adminDisplay]="adminDisplay" [uncorrectedUrl]="uncorrectedUrl" [displayPageFalse]="displayPageFalse"/>
